import { contentFocusTopBrandIdsAndLogos } from 'constants/welcome'
import { useObserver } from 'mobx-react-lite'
import { ContentGenderSelectBanner } from 'pages/Welcome/components/WelcomePageContentFocus/content/content-gender-select-banner'
import {
  ContentBannerSections,
  PageHolder,
  TopBrandsContentSection,
} from 'pages/Welcome/components/WelcomePageContentFocus/content/content-styles'
import { ContentUspBanner } from 'pages/Welcome/components/WelcomePageContentFocus/content/content-usp-banner'
import { TopBrandsContentFocus } from 'pages/Welcome/components/WelcomePageContentFocus/content/top-brands.content'
import { PromiseBar } from 'pages/Welcome/components/WelcomePageContentFocus/promise-bar.new'
import { SeoText } from 'pages/Welcome/components/WelcomePageContentFocus/seo-text.new'
import React, { FC } from 'react'
import { useCampaignStore, useConfigStore } from 'store/context'
import { MajorCampaignContentGenderSelectBanner } from './content/major-campaign-banner'
// eslint-disable-next-line no-restricted-imports
import type { GetGenderedCardsResponse_CardSliders_Card } from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.types'

export const WelcomePageContentFocus: FC<{
  campaignCard?: GetGenderedCardsResponse_CardSliders_Card
}> = ({ campaignCard }) => {
  const configStore = useConfigStore()
  const campaignStore = useCampaignStore()
  const welcomePageBlocks = useObserver(() => configStore.welcomePageBlocks)
  const campaignConditions = useObserver(() => campaignStore.conditions)

  return (
    <PageHolder>
      <PromiseBar isSmall />

      <ContentBannerSections>
        {campaignCard ? (
          <MajorCampaignContentGenderSelectBanner
            campaignImage={campaignCard.image.url}
            headline={campaignCard.headline}
            subline={campaignCard.subline}
            campaignConditions={campaignConditions}
            fallbackColor={campaignStore.campaignColor}
          />
        ) : (
          <ContentGenderSelectBanner {...welcomePageBlocks?.block1} />
        )}

        <ContentUspBanner {...welcomePageBlocks?.block2} />
      </ContentBannerSections>

      <TopBrandsContentSection>
        <TopBrandsContentFocus brands={contentFocusTopBrandIdsAndLogos} />
      </TopBrandsContentSection>
      <SeoText />
    </PageHolder>
  )
}
